var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{attrs:{"radius":"","color":"primary","type":"border","size":"small","icon":_vm.icon},on:{"click":function($event){$event.stopPropagation();_vm.preview = !_vm.preview}}}),(_vm.preview)?_c('action-timeline',{staticClass:"mt-6",attrs:{"automationId":_vm.automationId,"allowNewAction":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }